/* Reproduccion automatica de "Nuestras colecciones".
   Una interaccion del cliente pausa el avance y lo reactiva tras unos segundos. */
(function () {
  'use strict';

  if (window.__miColeccionesAutoplay) return;
  window.__miColeccionesAutoplay = true;

  var montadas = new WeakSet();
  var PAUSA_MANUAL = 8000;

  function montar(seccion) {
    if (montadas.has(seccion)) return;

    var pista = seccion.querySelector('[data-mi-riel]');
    var anterior = seccion.querySelector('[data-mi-prev]');
    var siguiente = seccion.querySelector('[data-mi-next]');
    if (!pista || !siguiente) return;

    montadas.add(seccion);

    var intervalo = parseInt(seccion.getAttribute('data-mi-colecciones-autoplay'), 10) || 4500;
    var temporizador = null;
    var visible = true;
    var hasta = 0;
    var interactuando = false;
    var reduccion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function detener() {
      if (temporizador) window.clearTimeout(temporizador);
      temporizador = null;
    }

    function programar(espera) {
      detener();
      if (!seccion.isConnected || !visible || interactuando || reduccion || document.hidden || pista.scrollWidth <= pista.clientWidth + 4) return;
      temporizador = window.setTimeout(avanzar, Math.max(espera == null ? intervalo : espera, hasta - Date.now()));
    }

    function avanzar() {
      temporizador = null;
      if (!visible || reduccion || document.hidden) return;

      if (pista.contains(document.activeElement)) {
        programar(intervalo);
        return;
      }

      var maximo = Math.max(0, pista.scrollWidth - pista.clientWidth);
      if (maximo < 4) return;

      if (pista.scrollLeft >= maximo - 4) {
        pista.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        siguiente.click();
      }

      programar(intervalo);
    }

    function pausaManual(evento) {
      if (evento && evento.type === 'click' && !evento.isTrusted) return;
      hasta = Date.now() + PAUSA_MANUAL;
      programar(PAUSA_MANUAL);
    }

    [anterior, siguiente].forEach(function (boton) {
      if (boton) boton.addEventListener('click', pausaManual);
    });

    pista.addEventListener('pointerdown', function () {
      interactuando = true;
      detener();
    }, { passive: true });
    function soltar() {
      if (!interactuando) return;
      interactuando = false;
      pausaManual();
    }
    window.addEventListener('pointerup', soltar, { passive: true });
    window.addEventListener('pointercancel', soltar, { passive: true });
    pista.addEventListener('wheel', pausaManual, { passive: true });
    pista.addEventListener('keydown', pausaManual);
    pista.addEventListener('focusin', pausaManual);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) detener();
      else programar(intervalo);
    });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          visible = entrada.isIntersecting;
          if (visible) programar(intervalo);
          else detener();
        });
      }, { threshold: 0.15 }).observe(seccion);
    } else {
      programar(intervalo);
    }
  }

  function montarTodas(raiz) {
    if (raiz.nodeType === 1 && raiz.matches('[data-mi-colecciones-autoplay]')) montar(raiz);
    raiz.querySelectorAll('[data-mi-colecciones-autoplay]').forEach(montar);
  }

  function arrancar() {
    montarTodas(document);
    new MutationObserver(function (cambios) {
      cambios.forEach(function (cambio) {
        cambio.addedNodes.forEach(function (nodo) {
          if (nodo.nodeType === 1) montarTodas(nodo);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
